export default function UACustomerController(
) {
  const vm = this;

  vm.canEdit = true;
  /** *****************************************
   * Event Handlers
   */
}

UACustomerController.$inject = [
];
